import * as React from 'react'
import Divider from '@mui/material/Divider'

import { OwnerFilter } from './OwnerFilter'
import { DueDateFilter } from './DueDateFilter'
import { StartDateFilter } from './StartDateFilter'
import { SalesTeamFilter } from './SalesTeamFilter'
import { SalesFunnelFilter } from './SalesFunnelFilter'
import { CreatedDateFilter } from './CreatedDateFilter'
import { ActivityTypeFilter } from './ActivityTypeFilter'
import type { IFilterMode } from '@user/components/Filters'

export function FilterContent(props: IFilterMode) {
  return (
    <>
      <ActivityTypeFilter {...props} />

      <Divider />

      <SalesFunnelFilter {...props} />
      <SalesTeamFilter {...props} />
      <OwnerFilter {...props} />

      <Divider />

      <CreatedDateFilter {...props} />
      <DueDateFilter {...props} />
      <StartDateFilter {...props} />
    </>
  )
}
